import { Context } from "@twii/common/lib/Context";
var StorageServiceContext = new Context({
    factory: function () {
        return import("./DefaultStorageServiceFactory").then(function (m) { return m.DefaultStorageServiceFactory(); });
    }
});
export { StorageServiceContext };
